// Note:
// Inside each key, the elements should be ordered alphabetically

export const ResourcesPT = {
    // Elements
    label: {
        advance: 'Avançar',
        anotherTopic: 'Outro assunto',
        campusAccess: 'Acessos',
        campusBuildings: 'Edifícios',
        campusEnergy: 'Energia/Iluminação',
        campusGreenSpaces: 'Espaços Verdes',
        campusParking: 'Cancelas e Estacionamento',
        campusWaste: 'Resíduos/Lixo',
        campusWatersSewers: 'Águas e Esgotos',
        campusWifi: 'Wi-Fi',
        /*
        campusAccess: 'Campus Acessos',
        campusBuildings: 'Campus Edifícios',
        campusEnergy: 'Campus Energia',
        campusGreenSpaces: 'Campus Espaços Verdes',
        campusParking: 'Campus Cancelas e Estacionamento',
        campusWaste: 'Campus Resíduos',
        campusWatersSewers: 'Campus Águas e Esgotos',
        campusWifi: 'Campus Wi-Fi',
        */
        cancel: 'Cancelar',
        configurations: 'Definições',
        doLogin: 'Faça Login',
        endSession: 'Terminar sessão',
        endSessionQuestion: 'Pretende terminar a sessão na aplicação?',
        exitApp: 'Sair da app',
        forgotPassword: 'Esqueceu-se da sua Password?',
        haveAnAccount: 'Já tem conta',
        hello: 'Olá',
        incidents: 'Incidentes',
        inMyIncidents: 'Nos meus incidentes',
        iReadAndAccept: 'Li e aceito',
        leaveComment: 'Deixar comentário',
        loading: 'Loading',
        login: 'Fazer Login',
        loginNova: 'Login NOVA',
        logout: 'Log out',
        map: {
            confirmYourLocation: 'Confirma a tua localização',
            continueWithLocation: 'Continuar com esta localização',
            outsideCampusLocation: 'A localização selecionada parece ser fora do campus',
            useMyLocation: 'Utilizar a minha localização',
        },
        my: 'Meus',
        myIncidents: 'Meus incidentes',
        newReport: 'Novo Report',
        newUser: 'Novo utilizador',
        noIncidents: 'Sem incidentes',
        noIncidentInThisState: 'Não existe nenhum incidente reportado neste estado',
        orConnectWith: 'ou ligue-se com',
        register: 'Registe-se',
        registerMe: 'Registe-me',
        reopenIncident: 'Reabrir incidente',
        reportIncident: 'Reportar o incidente',
        reports: 'Reports',
        severity: {
            low: 'Baixo',
            medium: 'Médio',
            high: 'Alto',
            warningLow: 'Necessidade de revisão, mas não limitadora.',
            warningMedium: 'Necessidade de revisão urgente, mas não impeditiva.',
            warningHigh: 'Necessidade de revisão imediata. Serviço indisponível.',
        },
        showYourLocation: 'Mostre a sua localização',
        status: {
            canceled: 'Cancelado',
            closed: 'Fechado',
            inProgress: 'Em curso',
            inValidation: 'Em análise',
            hold: 'Em pausa',
            registered: 'Registado',
            resolved: 'Resolvido',
            transferred: 'Transferido',
        },
        termsAndConditions: 'Termos e condições',
        tryAgain: 'Tentar novamente',
        universityLocation: 'Localização da universidade',
        uploadPhoto: 'Carregar Fotografia',
        viewPending: 'Ver Pendentes',
    },
    title: {
        welcomeToApp: 'Bem-vindo(a) à APP de reports',
        smartCampusCampolide: 'Smart Campus Campolide',
    },

    // Pages & Screens
    details: {
        followResolution: 'É este. Acompanhar resolução',
        doesIncidentOccur: 'Este incidente ainda se verifica?',
    },
    home: {
        title: 'Encontraste algum problema hoje?',
        paragraph: 'Centra o mapa no local da incidência (2 dedos para deslocar mapa)',
        pwaPrompt: {
            description: 'Adiciona esta app ao teu ecrã inicial para reportares incidentes de forma rápida',
            cta: 'Adicionar app',
        },
    },
    login: {
        heading: 'Pertence à comunidade da NOVA?',
        paragraph: 'Registe-se com o seu e-mail institucional',
    },
    noMatch: {
        ctaText: 'Voltar à página inicial',
        description: 'A página que procurou não existe ou está indisponivel neste momento.',
        title: 'Parece que esta página não existe',
    },
    pending: {
        bannerTitle: 'Pendentes',
        title: 'Incidentes reportados no Campus:',
    },
    profile: {
        tabs: {
            ongoingResolution: 'Resolução em curso',
            open: 'Aberto',
            resolved: 'Resolvido',
            underAnalysis: 'Em análise',
        },
    },
    report: {
        bannerTitle: 'Reportar uma incidência',
        step1: {
            checkingReportedIncidents: 'A verificar se existem incidentes reportados...',
            ctaText: 'Não encontrei o meu incidente reportado',
            title1: 'Escolhe o tema sobre o qual queres reportar um incidente.',
            title2: 'Já existem incidentes reportados semelhantes ao teu, verifica se é algum destes:',
        },
        step2: {
            title: 'Diz-nos alguns detalhes sobre o incidente.',
        },
        step3: {
            title: 'Adiciona uma fotografia do incidente (Opcional)',
            warningMessage: 'A imagem que tentaste inserir não tem as especificações corretas. Tenta novamente.',
        },
    },
    splashScreen: {
        description: 'Com a tua ajuda tornámos o Campus da Universidade NOVA um espaço melhor',
    },

    // Forms
    form: {
        confirmPwd: {
            label: 'Confirmar Password',
            placeholder: 'Confirmar Password',
            validate: {
                required: 'Confirmar palavra-passe é obrigatório',
                validate: 'As suas passwords não correspondem',
            },
        },

        email: {
            label: 'E-mail',
            placeholder: 'E-mail',
            validate: {
                required: 'E-mail é obrigatório',
                pattern: 'E-mail inválido',
            },
        },
        name: {
            label: 'Nome',
            placeholder: 'Nome',
            validate: {
                required: 'Nome é obrigatório',
            },
        },
        password: {
            label: 'Password',
            placeholder: 'Password',
            validate: {
                required: 'Palavra-passe é obrigatório',
                pattern:
                    'A sua palavra-passe deve conter uma letra maiúscula, uma letra minúscula, um número, um carácter especial e no mínimo 8 caracteres.',
            },
        },
        reopenIncident: {
            label: 'Reabrir incidente',
            placeholder: 'Deixa um comentário a dizer-nos porque queres reabrir este incidente',
            validate: {
                required: 'Reabrir incidente é obrigatório',
            },
        },

        // Report Form
        report: {
            description: {
                label: 'Descrição',
                placeholder: 'Descrição*',
                validate: {
                    required: "Descrição é obrigatória",
                }
            },
            dropdown: {
                label: 'Como caracterizas este incidente?*',
                placeholder: 'Como caracterizas este incidente?*',
            },
            severity: {
                label: 'Qual o grau de importância deste incidente?',
                placeholder: 'Qual o grau de importância deste incidente?',
            },
            title: {
                infoMessage: 'Escreve algo curto e simples como “Lâmpada fundida” ou “Buraco no chão',
                label: 'Título',
                placeholder: 'Título',
                validate: {
                    required: 'Título é obrigatório',
                },
            },
        },
        username: {
            label: 'Username',
            placeholder: 'Username',
            validate: {
                required: 'Username é obrigatório',
                pattern: 'Username inválido',
            },
        },
    },

    // Feedback Messages
    feedback: {
        successTitle: 'Sucesso!',
        errorTitle: 'Ups! Algo correu mal.',
        report: {
            errorDescription1:
                'Pedimos desculpa, mas não foi possível reportar o seu incidente. Por favor, tente mais tarde.',
            errorDescription2:
                'Pedimos desculpa, mas não foi possível acompanhar o incidente. Por favor, tente mais tarde',
            successDescription1: 'Podes acompanhar o seu estado no teu perfil.',
            successTitle: 'Obrigado pelo teu report!',
            successTitleReopen: 'Incidente reaberto!',
        },
    },
};
